//_SHIROMISAKANA_

import styled from '@emotion/styled'
import React, { useEffect } from 'react'
import { Platform } from '@/firebase/firestore/Platform'
import { Sex } from '@/firebase/firestore/Sex'
import { VoiceChat } from '@/firebase/firestore/VoiceChats'
import Image from 'next/image'
import fitty from 'fitty'

type Props = {
  targetId: string
  templateColor: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7
  uid: string
  name: string
  sex: Sex
  platform: Array<Platform>
  voiceChat: Array<VoiceChat>
  playStyle: string
  inviteStyle: string
  fontFamily: string
  fontColor: string
  playTimeWeekDayBegin: string
  playTimeWeekDayEnd: string
  playTimeWeekEndBegin: string
  playTimeWeekEndEnd: string
  playTime: string
  apexFavoriteWeapon: string
  apexMaxDamage: number
  hitokoto: string
  legends: number[]
}

export const Apex13: React.FC<Props> = ({
  uid,
  name,
  sex,
  fontFamily,
  fontColor,
  platform,
  voiceChat,
  playTimeWeekDayBegin,
  playTimeWeekDayEnd,
  playStyle,
  inviteStyle,
  playTime,
  templateColor,
  apexFavoriteWeapon,
  apexMaxDamage,
  hitokoto,
  legends,
  targetId,
}) => {
  useEffect(() => {
    fitty('#name', {
      maxSize: 16,
      minSize: 8,
    })
    fitty('#apexId', {
      maxSize: 12,
      minSize: 6,
    })
    fitty('#playTime', {
      maxSize: 16,
      minSize: 11,
    })
    fitty('#favoriteWeapon', {
      maxSize: 16,
      minSize: 12,
    })
    fitty('#hitokoto', {
      maxSize: 28,
      minSize: 12,
    })
  }, [])
  return (
    <Container id={targetId} fontFamily={fontFamily} fontColor={fontColor}>
      <Image
        width="1650"
        height="1100"
        alt={`Apex自己紹介カード ${templateColor}`}
        unoptimized={true}
        src={`/static/images/profiles/apex13/${templateColor}-min.jpeg`}
      />
      <Name>
        <span id="name">{name}</span>
      </Name>
      <Id>
        <span id="apexId">{uid}</span>
      </Id>
      {sex === 0 && <Sex0 />}
      {sex === 1 && <Sex1 />}
      {sex === 2 && <Sex2 />}
      {platform.includes(1) && <Platform0 />}
      {platform.includes(3) && <Platform1 />}
      {platform.includes(0) && <Platform2 />}
      {platform.includes(2) && <Platform3 />}

      {(voiceChat.includes(0) ||
        voiceChat.includes(1) ||
        voiceChat.includes(3)) && <VCOk />}
      {voiceChat.includes(4) && <VCNg />}

      {legends.includes(0) && <Legend0 />}
      {legends.includes(1) && <Legend1 />}
      {legends.includes(2) && <Legend2 />}
      {legends.includes(3) && <Legend3 />}
      {legends.includes(4) && <Legend4 />}
      {legends.includes(5) && <Legend5 />}
      {legends.includes(6) && <Legend6 />}
      {legends.includes(7) && <Legend7 />}
      {legends.includes(8) && <Legend8 />}
      {legends.includes(9) && <Legend9 />}
      {legends.includes(10) && <Legend10 />}
      {legends.includes(11) && <Legend11 />}
      {legends.includes(12) && <Legend12 />}
      {legends.includes(13) && <Legend13 />}
      {legends.includes(14) && <Legend14 />}
      {legends.includes(15) && <Legend15 />}
      {legends.includes(16) && <Legend16 />}
      {legends.includes(17) && <Legend17 />}
      {legends.includes(18) && <Legend18 />}
      {legends.includes(19) && <Legend19 />}
      {legends.includes(20) && <Legend20 />}
      {legends.includes(21) && <Legend21 />}
      {legends.includes(22) && <Legend22 />}
      {playTime !== '' && (
        <PlayTime>
          <span id="playTime">{playTime}</span>
        </PlayTime>
      )}
      {playTime === '' && (
        <PlayTimeBegin>{playTimeWeekDayBegin}:00</PlayTimeBegin>
      )}
      {playTime === '' && <PlayTimeEnd>{playTimeWeekDayEnd}:00</PlayTimeEnd>}
      {inviteStyle === 'dm' && <InviteStyle0 />}
      {inviteStyle === 'comment' && <InviteStyle1 />}
      {inviteStyle === 'lobby' && <InviteStyle2 />}
      {playStyle === 'vanguard' && <PlayStyle0 />}
      {playStyle === 'middleGuard' && <PlayStyle1 />}
      {playStyle === 'rearGuard' && <PlayStyle2 />}
      <MaxDamage>{apexMaxDamage}</MaxDamage>
      <FavoriteWeapon>
        <span id="favoriteWeapon">{apexFavoriteWeapon}</span>
      </FavoriteWeapon>
      <Hitokoto>
        <span id={'hitokoto'}>{hitokoto}</span>
      </Hitokoto>
    </Container>
  )
}

const Container = styled.div<{ fontFamily: string; fontColor: string }>`
  position: relative;
  width: 100%;
  line-height: 0;
  * {
    line-height: 1;
    font-family: ${({ fontFamily }) => fontFamily};
    color: ${({ fontColor }) => fontColor};
    border-color: ${({ fontColor }) => fontColor};
  }
`

const Name = styled.div`
  position: absolute;
  top: 3.5%;
  left: 20%;
  width: 18%;
  height: 14%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    letter-spacing: -2px;
    font-weight: bold;
  }
`

const Id = styled.div`
  position: absolute;
  top: 11%;
  left: 20%;
  width: 18%;
  height: 20%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    letter-spacing: -1px;
    font-weight: bold;
  }
`

const SexBase = styled.div`
  position: absolute;
  top: 4.5%;
  left: 26.5%;
  border-radius: 50%;
  border-style: solid;
  border-width: 2px;
  width: 12px;
  height: 12px;
`

const Sex0 = styled(SexBase)``
const Sex1 = styled(SexBase)`
  left: 29%;
`
const Sex2 = styled(SexBase)`
  left: 32.5%;
`

const PlatformBase = styled.div`
  position: absolute;
  top: 28.5%;
  left: 14.5%;
  border-radius: 50%;
  border-width: 2px;
  border-style: solid;
  width: 18px;
  height: 18px;
`

const Platform0 = styled(PlatformBase)``
const Platform1 = styled(PlatformBase)`
  left: 18.5%;
`
const Platform2 = styled(PlatformBase)`
  left: 22.5%;
`

const Platform3 = styled(PlatformBase)`
  left: 27%;
`

const VCOk = styled.div`
  position: absolute;
  top: 28.5%;
  left: 39%;
  border: solid 2px;
  border-radius: 50%;
  width: 18px;
  height: 18px;
`

const VCNg = styled.div`
  position: absolute;
  top: 28.5%;
  left: 42.5%;
  border: solid 2px;
  border-radius: 50%;
  width: 18px;
  height: 18px;
`

const TimeBase = styled.div`
  position: absolute;
  top: 38.5%;
  left: 21%;
  text-align: center;
  width: 18%;
  font-size: 16px;
  font-weight: bold;
`

const PlayTimeBegin = styled(TimeBase)``
const PlayTimeEnd = styled(TimeBase)`
  left: 33%;
`

const PlayTime = styled.div`
  position: absolute;
  top: 35.5%;
  left: 18.5%;
  text-align: center;
  width: 30%;
  word-break: break-all;
  height: 12%;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    text-align: center;
    font-weight: bold;
    line-height: 1.2;
  }
`

const LegendBase = styled.div`
  position: absolute;
  top: 6%;
  left: 54.5%;
  border-style: solid;
  border-width: 2px;
  border-radius: 50%;
  width: 35px;
  height: 35px;
`

const Legend0 = styled(LegendBase)``
const Legend1 = styled(LegendBase)`
  left: 65.5%;
`
const Legend2 = styled(LegendBase)`
  //ライフライン
  left: 76%;
`
const Legend3 = styled(LegendBase)`
  left: 87%;
`
const Legend4 = styled(LegendBase)`
  top: 21%;
  left: 54.5%;
`

const Legend5 = styled(LegendBase)`
  //バンガロール
  top: 21%;
  left: 65.5%;
`
const Legend6 = styled(LegendBase)`
  //ガス
  top: 21%;
  left: 76%;
`
const Legend7 = styled(LegendBase)`
  //ミラージュ
  top: 21%;
  left: 87%;
`
const Legend8 = styled(LegendBase)`
  //オクタン
  top: 36%;
  left: 54.5%;
`
const Legend9 = styled(LegendBase)`
  //ワトソン
  top: 36%;
  left: 65.5%;
`

const Legend10 = styled(LegendBase)`
  //クリプト
  top: 36%;
  left: 76%;
`

const Legend11 = styled(LegendBase)`
  top: 36%;
  left: 87%;
`

const Legend12 = styled(LegendBase)`
  //ローバ
  top: 51%;
  left: 54.5%;
`

const Legend13 = styled(LegendBase)`
  //ランパート
  top: 51%;
  left: 65.5%;
`

const Legend14 = styled(LegendBase)`
  //ホライゾン
  top: 51%;
  left: 76%;
`

const Legend15 = styled(LegendBase)`
  //ヒューズ
  top: 51%;
  left: 87%;
`

const Legend16 = styled(LegendBase)`
  //ヴァルキリー
  top: 66%;
  left: 54.5%;
`

const Legend17 = styled(LegendBase)`
  //シア
  top: 66%;
  left: 65.5%;
`

const Legend18 = styled(LegendBase)`
  top: 66%;
  left: 76%;
`

const Legend19 = styled(LegendBase)`
  top: 66%;
  left: 87%;
`

const Legend20 = styled(LegendBase)`
  top: 81%;
  left: 54.5%;
`

const Legend21 = styled(LegendBase)`
  top: 81%;
  left: 65.5%;
`

const Legend22 = styled(LegendBase)`
  top: 81%;
  left: 76%;
`

const MaxDamage = styled.span`
  position: absolute;
  top: 68%;
  left: 15.5%;
  text-align: center;
  width: 18%;
  height: 20%;
  font-size: 18px;
  font-weight: bold;
  word-break: break-all;
  line-height: 13px;
`

const InviteStyleBase = styled.div`
  position: absolute;
  top: 47.5%;
  left: 22.5%;
  border-style: solid;
  border-width: 2px;
  border-radius: 50%;
  width: 20px;
  height: 20px;
`

const InviteStyle0 = styled(InviteStyleBase)``

const InviteStyle1 = styled(InviteStyleBase)`
  left: 26.5%;
  width: 41px;
  height: 20px;
  border-radius: 12px;
`

const InviteStyle2 = styled(InviteStyleBase)`
  left: 36.5%;
  width: 41px;
  height: 20px;
  border-radius: 12px;
`

const PlayStyleBase = styled.div`
  position: absolute;
  top: 57%;
  left: 33.5%;
  border-style: solid;
  border-width: 2px;
  border-radius: 50%;
  width: 20px;
  height: 20px;
`

const PlayStyle0 = styled(PlayStyleBase)``

const PlayStyle1 = styled(PlayStyleBase)`
  left: 37.5%;
`

const PlayStyle2 = styled(PlayStyleBase)`
  left: 42%;
`

const FavoriteWeapon = styled.div`
  position: absolute;
  top: 70%;
  left: 19%;
  width: 28%;
  word-break: break-all;
  height: 20%;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    font-weight: bold;
    line-height: 1.2;
  }
`

const Hitokoto = styled.div`
  position: absolute;
  top: 82%;
  left: 15%;
  height: 15%;
  width: 34%;
  word-break: break-all;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    font-weight: bold;
    line-height: 1.2;
  }
`
